import React from 'react';
import { View, Pressable } from 'react-native';
import _ from 'lodash';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Colors from '../colors';
import Text from '../text';
import Icon from '../icon';
import Spacer from '../spacer';
import Status from '../status';
import Button from '../button';
import LabelDataPair from '../label-data-pair';
import useMobile from '../hooks/use-mobile';
const status = {
  disbursed: 'success',
  completed: 'success',
  cancelled: 'neutral',
  failed: 'error',
  processing: 'information',
  requested: 'information',
  none: ''
};
const StyledTransactionCard = styled.View`
  width: 100%;
  height: 73px;
  padding: 16px;
  background: ${props => props.isDefault ? Colors.lightGray200 : Colors.white};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.isDefault ? 'center' : 'space-between'};
  align-items: center;
  filter: ${props => (props.status !== 'none' || props.status === 'none' && props.amount !== '') && 'drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.1))'};
`;
const Row = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const AmountContainer = styled.View`
  min-width: ${props => props.isMobile ? 'auto' : 150}px;
`;
const StatusContainer = styled.View`
  margin-left: auto;
`;
const IconContainer = styled.View`
  background: ${Colors.lightGray200};
  border-radius: 4px;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export default function Card(props) {
  const isDefault = props.amount === '';
  const isMobile = useMobile();
  const IconFamily = props.icon === 'more-horiz' ? Icon.MaterialIcons : Icon.AdvanceLineIcon;
  return /*#__PURE__*/React.createElement(StyledTransactionCard, {
    isDefault: isDefault,
    status: props.status,
    amount: props.amount
  }, props.amount !== '' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(IconFamily, {
    name: props.icon,
    color: props.iconColor,
    size: 25
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }), /*#__PURE__*/React.createElement(AmountContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/React.createElement(LabelDataPair, {
    type: "bottom-left",
    label: props.purpose,
    truncated: true
  }, props.amount)), !isMobile && props.referenceNo !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelDataPair, {
    type: "bottom-left",
    label: "Reference No."
  }, props.referenceNo))), /*#__PURE__*/React.createElement(Pressable, {
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(Row, null, props.status !== 'none' ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(StatusContainer, null, /*#__PURE__*/React.createElement(Status, {
    type: status[props.status]
  }, _.capitalize(props.status))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    height: true
  }), isMobile && props.referenceNo !== '' && /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.gray200
  }, "Ref No.", ' ', props.referenceNo)) : /*#__PURE__*/React.createElement(Button.Text, {
    onPress: props.onPress
  }, "Continue"), /*#__PURE__*/React.createElement(Spacer, {
    size: "d24",
    width: true
  }), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "chevron-right",
    size: 24
  })))) : /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray200
  }, props.defaultText));
}
Card.defaultProps = {
  icon: 'id',
  iconColor: Colors.purple400,
  amount: '',
  purpose: '',
  referenceNo: '',
  status: 'none',
  onPress: () => {},
  defaultText: 'No Payments Due'
};
Card.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  amount: PropTypes.string,
  purpose: PropTypes.string,
  referenceNo: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(status)),
  onPress: PropTypes.func,
  defaultText: PropTypes.string
};
//# sourceMappingURL=card.js.map